import type { FC } from 'react';
import React, { Fragment } from 'react';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import type { ExperienceAttributes } from '@confluence/experience-tracker/entry-points/ExperienceEvent.ts';
import {
	ExperienceStart,
	ExperienceStop,
} from '@confluence/experience-tracker/entry-points/component.ts';

import { LoadingState } from './homeViewsQueryHelpers.ts';

type ExperienceTrackingType = {
	experienceName: string;
	loading: LoadingState;
	error?: ApolloErrorInterop;
	attributes?: ExperienceAttributes;
};

export const ExperienceTracking: FC<ExperienceTrackingType> = ({
	experienceName,
	loading,
	error,
	attributes,
}) => {
	return (
		<Fragment>
			<ExperienceStart name={experienceName} />
			{loading === LoadingState.done && (
				<ExperienceStop name={experienceName} error={error} attributes={attributes} />
			)}
		</Fragment>
	);
};
